export { default as translations } from './translations.json';

export const ALLOWED_OPERATIONS = ['price', 'availability', 'publish', 'close', 'tags'];
export const MAX_BATCH = 50;

/**
 * Validate bulk edit request.
 * @param {string[]} listingIds
 * @param {string} operation
 * @returns {string|null}
 */
export const validateBulkEdit = (listingIds, operation) => {
  if (!Array.isArray(listingIds) || listingIds.length === 0) return 'At least one listing required';
  if (listingIds.length > MAX_BATCH) return `Max ${MAX_BATCH} listings per operation`;
  if (!ALLOWED_OPERATIONS.includes(operation)) return 'Invalid operation';
  return null;
};

/**
 * Build tag update operation.
 * @param {string[]} existingTags
 * @param {string[]} add
 * @param {string[]} remove
 * @returns {string[]}
 */
export const applyTagUpdate = (existingTags = [], add = [], remove = []) =>
  [...new Set([...existingTags, ...add].filter(t => !remove.includes(t)))];
